import React from 'react';
import {Box, Pagination, Typography} from '@mui/material';
import {PAGE_SIZE} from './usePagination';

/**
 * Consistent pagination footer for KB entity detail tabs.
 *
 * Renders nothing when `hasPagination` is false (single page).
 *
 * @param {Object}   props
 * @param {boolean}  props.hasPagination  - Show the control at all.
 * @param {number}   props.page           - Current 1-based page.
 * @param {number}   props.totalPages     - Total number of pages.
 * @param {number}   props.totalItems     - Total item count (for the range label).
 * @param {Function} props.onChange       - Called with the new page number.
 * @param {number}   [props.pageSize]     - Items per page (default PAGE_SIZE).
 */
const TabPagination = ({hasPagination, page, totalPages, totalItems, onChange, pageSize = PAGE_SIZE}) => {
    if (!hasPagination) return null;

    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, totalItems);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1.5,
                borderTop: 1,
                borderColor: 'divider',
                bgcolor: 'background.paper',
            }}
        >
            <Typography variant="caption" color="text.secondary">
                {start}–{end} of {totalItems}
            </Typography>
            <Pagination
                count={totalPages}
                page={page}
                onChange={(_, v) => onChange(v)}
                size="small"
                shape="rounded"
                showFirstButton
                showLastButton
            />
        </Box>
    );
};

export default TabPagination;
